export default __webpack_public_path__ + "static/media/ACC.0651df43.png";